import { render, staticRenderFns } from "./IndexTask.vue?vue&type=template&id=ae20591c&"
import script from "./IndexTask.vue?vue&type=script&lang=js&"
export * from "./IndexTask.vue?vue&type=script&lang=js&"
import style0 from "./IndexTask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae20591c')) {
      api.createRecord('ae20591c', component.options)
    } else {
      api.reload('ae20591c', component.options)
    }
    module.hot.accept("./IndexTask.vue?vue&type=template&id=ae20591c&", function () {
      api.rerender('ae20591c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/IndexTask.vue"
export default component.exports